import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ApiProvider, createQueryClient } from '@blimo/api-client/react';
import { Toaster, TooltipProvider } from '@blimo/ui';
import { createAppRouter } from './router.jsx';
import { AppBranding } from './lib/branding.jsx';

/**
 * @param {{ api: import('@blimo/api-client').BlimoApi, history?: import('@tanstack/react-router').RouterHistory }} props
 */
export function App({ api, history }) {
  const [{ queryClient, router }] = useState(() => {
    /** @type {ReturnType<typeof createAppRouter>} */
    let appRouter;
    const client = createQueryClient({
      onUnauthenticated: () => {
        client.clear();
        const { pathname, href } = appRouter.state.location;
        if (!pathname.startsWith('/login')) appRouter.navigate({ to: '/login', search: { redirect: href } });
      },
    });
    appRouter = createAppRouter({ queryClient: client, api, history });
    return { queryClient: client, router: appRouter };
  });

  return (
    <ApiProvider api={api}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <AppBranding>
            <RouterProvider router={router} />
          </AppBranding>
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </ApiProvider>
  );
}
